import register from '../register';

register( 'clicks', function() {
  let elems;

  elems = Array.prototype.slice.call(
    document.querySelectorAll('.js-click-event')
  );

  elems.forEach( function( elem ) {
    elem.addEventListener( 'click', function( ev ) {
      window.dataLayer.push({ event: ev.currentTarget.dataset.event });
    });
  });

});

export default undefined;
